// The proforma number is the product's recurring object (root CLAUDE.md,
// "The signature element"): top-left on every screen and on the PDF, in
// tabular figures, with a rule beneath carrying status —
//   dashed grey   — no number allocated yet
//   solid violet  — approved
//   doubled violet — stamped and sent
//   solid amber   — revised, superseded
// Status is expressed through this rule, NOT a coloured chip/pill. Built
// once here and reused everywhere (this task's brief) — the sales pricing
// workspace (the only consumer today) only ever renders the `unallocated`
// state, since nothing reachable from it advances a quotation to
// `approved`; the other three states exist and are exercised by this
// component's own logic today even though no live screen reaches them yet,
// so the later admin approval screen can import this unchanged.

import { t } from '../../i18n/index.js';
import styles from './SignatureElement.module.css';

export const SIGNATURE_STATUSES = ['unallocated', 'approved', 'stamped', 'revised'];

const RULE_CLASS_BY_STATUS = {
  unallocated: styles.ruleUnallocated,
  approved: styles.ruleApproved,
  stamped: styles.ruleStamped,
  revised: styles.ruleRevised,
};

export function SignatureElement({ proformaNo, status = 'unallocated', lang, showLegend = false }) {
  const safeStatus = SIGNATURE_STATUSES.includes(status) ? status : 'unallocated';
  const ruleClass = RULE_CLASS_BY_STATUS[safeStatus];

  return (
    <div className={styles.wrapper}>
      <div className={styles.numberRow}>
        <span className={styles.label}>{t('signature.proformaNumber', lang)}</span>
        {/* The status line below the rule already says "Not yet allocated"
            (signature.status.unallocated) for every status this renders —
            this slot just needs a placeholder, not a second statement of
            the same fact (this task's brief: redundant, keep one). */}
        <span className={styles.number}>{proformaNo || '—'}</span>
      </div>
      <div className={`${styles.rule} ${ruleClass}`} aria-hidden="true" />
      <div className={styles.statusText}>{t(`signature.status.${safeStatus}`, lang)}</div>

      {showLegend && (
        <dl className={styles.legend}>
          <dt className={styles.legendTitle}>{t('signature.legend.title', lang)}</dt>
          {SIGNATURE_STATUSES.map((s) => (
            <dd key={s} className={styles.legendItem}>
              <span
                className={`${styles.legendSwatch} ${RULE_CLASS_BY_STATUS[s]}`}
                aria-hidden="true"
              />
              {t(`signature.legend.${s}`, lang)}
            </dd>
          ))}
        </dl>
      )}
    </div>
  );
}

export default SignatureElement;
